const CartUtils = {}

CartUtils.GOGREEN_PRODUCT_ID = '51242305519963';

CartUtils.getCheckboxes = function() {
    return {
        drawer: document.querySelector('#contrib-cart-drawer .contrib__checkbox input'),
        main: document.querySelector('#contrib-main-cart .contrib__checkbox input')
    };
};

CartUtils.hasGoGreenProduct = function(cartData) {
    return cartData.items.some(item => item.id == CartUtils.GOGREEN_PRODUCT_ID);
};

CartUtils.syncCheckboxState = function(cartData) {
    const checkboxes = CartUtils.getCheckboxes();
    const hasProduct = CartUtils.hasGoGreenProduct(cartData);
    
    if (checkboxes.drawer) {
        checkboxes.drawer.checked = hasProduct;
    }
    if (checkboxes.main) {
        checkboxes.main.checked = hasProduct;
    }
};

CartUtils.syncWithCurrentCart = async function() {
    try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        const cartData = await response.json();
        CartUtils.syncCheckboxState(cartData);
        CartUtils.setupCheckboxListeners();
    } catch (error) {
        console.error('Error syncing with current cart:', error);
    }
};

CartUtils.addGoGreenProduct = async function() {
    const body = JSON.stringify({
        id: CartUtils.GOGREEN_PRODUCT_ID,
        quantity: 1,
    });
    
    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json', 
            'Accept': 'application/json' 
        },
        body: body
    });
};

CartUtils.removeGoGreenProduct = async function() {
    const body = JSON.stringify({
        id: CartUtils.GOGREEN_PRODUCT_ID,
        quantity: 0,
    });
    
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json', 
            'Accept': 'application/json' 
        },
        body: body
    });
};

CartUtils.reloadCart = function(isDrawerContext = false) {
    if (isDrawerContext) {
        // For drawer context, just refresh the cart without page reload
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            // After cart refresh, sync checkbox state and re-setup listeners
            setTimeout(async () => {
                try {
                    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    });
                    const cartData = await response.json();
                    CartUtils.syncCheckboxState(cartData);
                    CartUtils.setupCheckboxListeners();
                } catch (error) {
                    console.error('Error syncing checkbox state after cart refresh:', error);
                }
            }, 200);
        }, 300);
    } else {
        // For main cart context, do a full page reload
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.location.reload();
        }, 500);
    }
};

CartUtils.setupCheckboxListeners = function() {
    const checkboxes = CartUtils.getCheckboxes();
    
    // Handle drawer checkbox
    if (checkboxes.drawer && !checkboxes.drawer.dataset.listenerAdded) {
        checkboxes.drawer.addEventListener('change', async function(e) {
            if (e.target.checked) {
                await CartUtils.addGoGreenProduct();
            } else {
                await CartUtils.removeGoGreenProduct();
            }
            // Pass true to indicate drawer context (no page reload)
            CartUtils.reloadCart(true);
        });
        checkboxes.drawer.dataset.listenerAdded = 'true';
    }
    
    // Handle main cart checkbox
    if (checkboxes.main && !checkboxes.main.dataset.listenerAdded) {
        checkboxes.main.addEventListener('change', async function(e) {
            if (e.target.checked) {
                await CartUtils.addGoGreenProduct();
            } else {
                await CartUtils.removeGoGreenProduct();
            }
            // Pass false to indicate main cart context (page reload)
            CartUtils.reloadCart(false);
        });
        checkboxes.main.dataset.listenerAdded = 'true';
    }
};

CartUtils.addGoGreen = function (formSelector) {
    var cart_drawer_form = document.querySelector(formSelector);
  
    cart_drawer_form.addEventListener('submit', async function (e) {
      e.preventDefault();
      
      // check if the checkbox is checked
        var checkbox_drawer = document.querySelector('#contrib-cart-drawer .contrib__checkbox input');
        var checkbox = document.querySelector('#contrib-main-cart .contrib__checkbox input');
        if(checkbox){
            if (!checkbox.checked && !checkbox_drawer.checked) {
                // if not checked, proceed to checkout without adding the contribution
                window.location.href = '/checkout';
                return;
            } 
        } else {
            if (!checkbox_drawer.checked) {
                // if not checked, proceed to checkout without adding the contribution
                window.location.href = '/checkout';
                return;
            } 
        }
      // get cart data as json
      const response = await fetch(`${routes.cart_url}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
  
      const data = await response.json();
        var dont_add = false;

      for (var i = 0; i < data.items.length; i++) {
        if(data.items[i].id == '51242305519963'){
            dont_add = true;
            break;
        }
      }
      if(!dont_add){
        var body = JSON.stringify({
            id: '51242305519963',
            quantity: 1,
        });
        var fetchConfig = function(type = 'json') {
            return {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
            };
        }
        await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } });
      }
  
      window.location.href = '/checkout';
  
    });
  }

// Initialize cart change listener to sync checkbox state
document.addEventListener('cart:change', function(event) {
    if (event.detail && event.detail.cart) {
        CartUtils.syncCheckboxState(event.detail.cart);
        // Re-setup listeners after cart changes in case DOM was updated
        setTimeout(() => {
            CartUtils.setupCheckboxListeners();
        }, 100);
    }
});

// Listen for variant:add events (when products are added from product pages)
document.addEventListener('variant:add', function(event) {
    if (event.detail && event.detail.cart) {
        CartUtils.syncCheckboxState(event.detail.cart);
        // Re-setup listeners after variant addition
        setTimeout(() => {
            CartUtils.setupCheckboxListeners();
        }, 100);
    }
});

// Listen for drawer open events to sync checkbox state
document.addEventListener('dialog:after-show', function(event) {
    // Check if it's the cart drawer being opened
    if (event.target && event.target.id === 'cart-drawer') {
        // Sync with current cart state when drawer opens
        setTimeout(() => {
            CartUtils.syncWithCurrentCart();
        }, 100);
    }
});

// Also listen for any cart refresh events
document.addEventListener('cart:refresh', function() {
    setTimeout(() => {
        CartUtils.syncWithCurrentCart();
    }, 200);
});

// Initialize checkbox listeners when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    CartUtils.setupCheckboxListeners();
    
    // Also set up listeners after cart updates
    document.addEventListener('cart:change', function() {
        setTimeout(() => {
            CartUtils.setupCheckboxListeners();
        }, 100);
    });
});

// Set up initial cart state check
window.addEventListener('load', async function() {
    try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        const cartData = await response.json();
        CartUtils.syncCheckboxState(cartData);
        CartUtils.setupCheckboxListeners();
    } catch (error) {
        console.error('Error loading initial cart state:', error);
    }
});

CartUtils.addGoGreen('cart-drawer form.buy-buttons');
if(document.querySelector('.shopify-section--main-cart form.cart-form')){
    CartUtils.addGoGreen('.shopify-section--main-cart form.cart-form');
}
window.CartUtils = CartUtils;